import axios from 'axios'
export default {
    SearchSchool(params) {
        return axios({
            url: '/school/list',
            method: 'get',
            params: params
        })
            .then((res) => res)
            .catch((err) => err)
    },
}